<div [formGroup]="group" *ngIf="group">
	<mat-form-field appearance="fill">
		<mat-label>Recurso</mat-label>
		<input
			type="text"
			placeholder="Seleccionar un recurso"
			aria-label="Recurso"
			matInput
			[formControl]="formControl"
			[formControlName]="formControlName"
			[matAutocomplete]="auto"
			(keyup)="onWriteResource($event)"
		/>
		<mat-autocomplete
			autoActiveFirstOption
			#auto="matAutocomplete"
			[displayWith]="getOptionText"
			(optionSelected)="resourceSelected($event)"
		>
			<mat-option
				*ngFor="let option of filteredOptions"
				[value]="option"
				[ngClass]="{
					createNew: option.id === 'addNew',
					editableOption: isEditEnabled(option)
				}"
			>
				<mat-icon *ngIf="option.id === 'addNew'">add_circle</mat-icon>
				<span>
					{{ option.name }}
				</span>
				<mat-icon
					*ngIf="option.id !== 'addNew' && isEditEnabled(option)"
					(click)="editResource($event, option)"
					class="edit-resource-icon"
					>edit</mat-icon
				>
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>
</div>
